import { TCustomerFavoriteSharedDeletePayload } from '@ephatta/services';
import { useEphattaMutation } from '../../..';
import { useCustomerFavoriteService } from './useCustomerFavoriteService';

export const useCustomerFavoriteDeleteShared = () => {
    const service = useCustomerFavoriteService()
    return useEphattaMutation(
        (payload: TCustomerFavoriteSharedDeletePayload) => service.deleteShared(payload)
    )
} 